module.exports = __webpack_public_path__ + "static/media/Бадулина Н. А. (КФА).1bef1bf8.pdf";